

<div class="content p-24">
    <div class="example-viewer-wrapper mat-white-bg mat-elevation-z2">
  
        <div class="example-viewer-header">
            <div class="example-viewer-title"><h1>{{'HOME.HELLO' | translate}}</h1></div>
        </div>
          
      <div class="example-viewer-body" >
          <div class="example-container">
            <b><p>{{'HOME.Wat' | translate}}</p></b>
         
          
            <div id='calendar'></div>


          </div>
             
    
      </div>
    </div>
</div>